import { ErrorMessage } from 'nhsuk-react-components';
import { ApiError } from '../../schemas/ApiError.schema';

interface ApiErrorDetailsProps {
    apiError: ApiError | null;
}

function ApiErrorDetails({
  apiError,
}: ApiErrorDetailsProps) {
  if (!apiError || (!apiError.message)) {
    return null;
  }

  return (
    <ErrorMessage data-testid="api-error-details">
      {apiError.message && <div>{apiError.message}</div>}
      {apiError.errors && (
        <div>
          <ul>
            {Object.entries(apiError.errors).map(([key, messages]) => (
              <ul key={key}>
                {messages.map((message) => (
                  <li key={`${key}-${message}`}>{message}</li>
                ))}
              </ul>
            ))}
          </ul>
        </div>
      )}
    </ErrorMessage>
  );
}

export default ApiErrorDetails;
